import classNames from 'class-names';
import PropTypes from 'prop-types';
import React from 'react';

import useSmallScreen from '../../lib/hooks/useSmallScreen';
import TableTransposed from '../../Molecules/Tables/TableTransposed';

import PortEnableDisableBtn from './PortEnableDisableBtn';
import PortIcon from './PortIcon';
import { poweredDownPortsProps, switchProps } from './propTypes';

const portMapping = {
  port1: 'Port 1',
  port2: 'Port 2',
  port3: 'Port 3',
  port4: 'Port 4',
  wifi: 'Wi-Fi',
};

const getSwitchDataArray = (layout) => {
  if (Array.isArray(layout)) return layout;

  return Object.keys(layout).map((type) => {
    return {
      ...layout[type],
      id: type,
    };
  });
};

const ChannelsTable = ({
  switchData,
  portStatus,
  children,
  editing,
  poweredDownPorts,
  noInternetPorts,
}) => {
  const isMediumScreen = useSmallScreen('md');
  return (
    <TableTransposed
      className="table table-bordered mb-0"
      isCompact={isMediumScreen}
    >
      {getSwitchDataArray(switchData.ports).map((port, index) => {
        const { label, id, type } = port;

        const isPoweredDownPort =
          id === 'wifi' && portStatus.wifi === 'disabled'
            ? true
            : poweredDownPorts.includes(index + 1);
        const isNoInternetPort = noInternetPorts.includes(index + 1);
        const switchStatus = isPoweredDownPort ? 'Off' : 'On';
        return (
          <tr key={id}>
            <th
              className={
                isMediumScreen
                  ? 'text-uppercase text-sm'
                  : 'align-middle text-uppercase small font-weight-bold'
              }
              style={{ width: 140 }}
            >
              {portMapping[id]}
            </th>
            <td
              className={classNames(
                { 'text-gray-500': isPoweredDownPort },
                'align-items-center justify-content-between',
              )}
            >
              <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                  <PortIcon
                    id={id}
                    type={type}
                    status={portStatus}
                    isPoweredDownPort={isPoweredDownPort}
                    isNoInternetPort={isNoInternetPort}
                  />
                  <span className="ml-2">{label}</span>
                </div>
                <div className="text-right ml-3">
                  {id !== 'wifi' ? (
                    <div>
                      {editing ? (
                        <PortEnableDisableBtn id={id} />
                      ) : (
                        switchStatus
                      )}
                    </div>
                  ) : (
                    <div>{children}</div>
                  )}
                </div>
              </div>
            </td>
          </tr>
        );
      })}
    </TableTransposed>
  );
};

ChannelsTable.propTypes = {
  children: PropTypes.node.isRequired,
  poweredDownPorts: poweredDownPortsProps,
  noInternetPorts: poweredDownPortsProps,
  editing: PropTypes.bool.isRequired,
  portStatus: PropTypes.shape({
    wifi: PropTypes.string.isRequired,
  }).isRequired,
  switchData: switchProps,
};

export default ChannelsTable;
